import React from 'react';

function About() {
  return (
    <div className="slds-grid slds-gutters">
      <div className="slds-col slds-size_1-of-1">
        <div className="slds-card">
          <div className="slds-card__body slds-card__body_inner">
            <h1 className="slds-text-heading_large slds-p-bottom_medium">About Us</h1>
            
            <div className="slds-text-longform">
              <h2 className="slds-text-heading_medium slds-p-bottom_small">Our Approach</h2>
              <p className="slds-p-bottom_medium">
                At Peak Autism Center, we specialize in Applied Behavior Analysis (ABA) therapy, an evidence-based approach 
                that has been proven effective in helping individuals with autism spectrum disorder develop essential life skills 
                and reduce challenging behaviors.
              </p>

              <h2 className="slds-text-heading_medium slds-p-bottom_small">Our Team</h2>
              <p className="slds-p-bottom_medium">
                Our team consists of highly qualified and experienced professionals, including Board Certified Behavior Analysts 
                (BCBAs) and Registered Behavior Technicians (RBTs), who are dedicated to providing the highest quality of care 
                to our clients.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About; 